/**
 * Dadware cart drawer — dw-cart.js (deferred; needs dw-commerce.js).
 * Handles the multi-buy ladder's "Add another" button. The add is always an
 * explicit tap; nothing is ever added automatically. Quantity changes and
 * removals stay with Dawn's cart.js.
 */
(() => {
  'use strict';

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-dw-ladder-add]');
    if (!button || button.disabled || !window.DW || typeof window.DW.addToCart !== 'function') return;
    event.preventDefault();

    const ladder = button.closest('[data-dw-ladder]');
    const error = ladder && ladder.querySelector('[data-dw-ladder-error]');
    const quantity = Math.max(1, parseInt(button.dataset.quantity, 10) || 1);
    const variantId = Number(button.dataset.variantId);

    if (error) error.textContent = '';
    button.disabled = true;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    try {
      await window.DW.addToCart([{ id: variantId, quantity }], { source: 'cart-ladder', eventTarget: button });
      window.DW.track('ladder_add', { variantId, quantity });
      const status = document.getElementById('CartDrawer-LiveRegionText');
      if (status) status.textContent = window.DW.string('added');
      document.querySelector('cart-drawer .drawer__inner')?.focus({ preventScroll: true });
    } catch (err) {
      if (error) error.textContent = (err && err.message) || window.DW.string('error_generic');
      if (button.isConnected) {
        button.disabled = false;
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      }
    }
  });
})();
